import { TableColumnDefinition } from '@fluentui/react-components'
import { createTableColumn } from '@fluentui/react-components'
import { ApplicationRoleItem } from '../AppRolesPanel'
import { RowActionsMenu } from './RowActionsMenu'

export const appRolesTableColumns: TableColumnDefinition<ApplicationRoleItem>[] = [
  createTableColumn<ApplicationRoleItem>({
    columnId: 'name',
    compare: (a, b) => {
      return a.name.value.localeCompare(b.name.value)
    },
    renderHeaderCell: () => {
      return 'Name'
    },
    renderCell: (item) => {
      return item.name.value
    },
  }),
  createTableColumn<ApplicationRoleItem>({
    columnId: 'description',
    compare: (a, b) => {
      return a.description.value.localeCompare(b.description.value)
    },
    renderHeaderCell: () => {
      return 'Description'
    },
    renderCell: (item) => {
      return item.description.value
    },
  }),
  createTableColumn<ApplicationRoleItem>({
    columnId: 'memberCount',
    compare: (a, b) => {
      return a.memberCount.value - b.memberCount.value
    },
    renderHeaderCell: () => {
      return 'Member Count'
    },
    renderCell: (item) => {
      return item.memberCount.value
    },
  }),
  createTableColumn<ApplicationRoleItem>({
    columnId: 'teamCount',
    compare: (a, b) => {
      return a.teamCount.value - b.teamCount.value
    },
    renderHeaderCell: () => {
      return 'Team Count'
    },
    renderCell: (item) => {
      return item.teamCount.value
    },
  }),
  createTableColumn<ApplicationRoleItem>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => {
      return <RowActionsMenu item={item} />
    },
  }),
]
